import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, switchMap, tap } from 'rxjs';
import { GroupService } from './group.service';
import { PracticeSettingsStore } from './practice-settings-store.service';

@Injectable({
  providedIn: 'root'
})
export class CodingBundleService {
  private apiUrl = 'api/coding-bundles';
  codingBundlesSubject = new BehaviorSubject<any>(null);
  codingBundles$ = this.codingBundlesSubject.asObservable();
  private groupId?: string;

  constructor(
    private http: HttpClient,
    private groupService: GroupService,
    private settingsStore?: PracticeSettingsStore,
  ) {
    this.groupService.selectedGroup$.pipe(
      switchMap(selectedGroup => {
        if (selectedGroup) {
          this.groupId = selectedGroup.id;
          return this.getCodingBundlesByGroup(true);
        }
        return EMPTY;
      })
    ).subscribe();
  }

  /** `fromKeptCopy`: on a practice switch, the device's kept copy while it is current (PracticeSettingsStore). */
  getCodingBundlesByGroup(fromKeptCopy = false): Observable<any> {
    const token = localStorage.getItem('token');
    const request = this.http.get(`${this.apiUrl}/group/${this.groupId}`, { headers: { Authorization: `Bearer ${token}` } });
    const source = fromKeptCopy && this.settingsStore ? this.settingsStore.read(this.groupId!, 'codingBundles', () => request) : request;
    return source
      .pipe(
        tap(results => { this.codingBundlesSubject.next(results); })
      );
  }

  updateCodingBundles(codingBundles: any[]): Observable<any> {
    const token = localStorage.getItem('token');
    codingBundles = codingBundles.map((cb: any) => { return { groupId: this.groupId, ...cb } })
    return this.http.put(`${this.apiUrl}`, codingBundles, {
      headers: { Authorization: `Bearer ${token}` }
    })
  }

  deleteCodingBundle(id: string): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.delete(`${this.apiUrl}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
  }
}
